import { Link } from 'react-router-dom'
import classes from './ChatWidget.module.scss'
import { IconBot, IconChevron, IconClose } from './icons'
import { SURVEY_INVITE_PATH } from './surveyInvite'

interface Props {
  /** Gövdeye tıklandı → anket sayfasına SPA içinde gidilir. */
  onGo: () => void
  /** X'e tıklandı → baloncuk bu sekmede bir daha çıkmaz. */
  onDismiss: () => void
}

/**
 * Ana sayfada, panel kapalıyken FAB'in solunda çıkan anket daveti. `IntroNudge` görünümünü
 * paylaşır; gövde bir `<Link>`, kapat butonu onun kardeşidir (iç içe etkileşimli öğe kurulmaz).
 */
export default function SurveyNudge({ onGo, onDismiss }: Props) {
  return (
    <div className={classes.introNudge} role='status' aria-live='polite'>
      <Link to={SURVEY_INVITE_PATH} className={`${classes.introNudgeBody} ${classes.surveyNudgeBody}`} onClick={onGo}>
        <span className={classes.introNudgeAvatar}>
          <IconBot />
        </span>
        <span className={classes.introNudgeText}>
          <strong>Görüşleriniz benim için çok değerli!</strong>
          Kısa değerlendirme anketine katılarak gelişimime katkı sağlayın.
          <span className={classes.surveyNudgeCta}>
            Ankete katıl
            <IconChevron />
          </span>
        </span>
      </Link>
      <button type='button' className={classes.introNudgeClose} onClick={onDismiss} aria-label='Anket davetini kapat'>
        <IconClose />
      </button>
    </div>
  )
}
